import { api } from "boot/axios";
import { LocalStorage } from "quasar";

export default () => {
  // Mutual fund Wise Stocks
  const MutualFundWiseStocks = async (id) => {
    try {
      const data = await api.get(`/mutual-fund/?mutual_fund=${id}`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Stock Wise Mutual fund
  const StockWiseMutualFund = async (id) => {
    try {
      const data = await api.get(`/mutual-fund/?bought_stocks=${id}`);
      return data;
    } catch (error) {
      throw error;
    }
  };
  // Stock Wise Mutual fund
  const MutualFundFinancial = async (id) => {
    try {
      const data = await api.get(`/mutual-fund-financial/${id}/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Stock Wise Mutual fund
  const MutualFundTopHolding = async () => {
    try {
      const data = await api.get(`/mutual-fund-top-holdings/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Stock Wise Mutual fund
  const MutualFundSectorTopHolding = async () => {
    try {
      const data = await api.get(`/mutual-fund-sector-top-holdings/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Mutual Fund Sector Summary
  const MutualFundSectorSummary = async () => {
    try {
      const data = await api.get(`/mutual-fund-sector-summary/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Mutual Fund Sector Distri
  const MutualFundSectorDistri = async () => {
    try {
      const data = await api.get(`/mutual-fund-sector-distri/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  // Nav Vs Price
  const NavVsPrice = async () => {
    try {
      const data = await api.get(`/nav-vs-price/`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    NavVsPrice,
    StockWiseMutualFund,
    MutualFundWiseStocks,
    MutualFundFinancial,
    MutualFundTopHolding,
    MutualFundSectorTopHolding,
    MutualFundSectorSummary,
    MutualFundSectorDistri,
  };
};
